import { createContext, useContext } from "react"
import { usePath } from "../libs/path/PathProvider"

export type TPortFilterContext = {
    account:number
    search:string
    setAccount:(account:number) => void
    setSearch:(search:string) => void
}

const PortFilterContext = createContext<TPortFilterContext>({} as any)
export const usePortFilter = () => useContext(PortFilterContext)

export default function PortFilterProvider(props:{children:any}) {
    const {query,setQuery} = usePath()
    const account = query.account ? parseInt(query.account as string) : -1
    const search = query.search as string || ""
    const setAccount = (account:number) => setQuery({account})
    const setSearch = (search:string) => setQuery({search:search.toUpperCase()})
    return <PortFilterContext.Provider value={{account,search,setAccount,setSearch}}>
        {props.children}
    </PortFilterContext.Provider>
}